import React from 'react';

import classNames from 'classnames';

import * as classes from './style.module.scss';

interface Props {
  className?: string;
}

export const CodeBlockContainer: React.FC<Props> = ({
  className,
  children,
}) => {
  return <div className={classNames(classes.root, className)}>{children}</div>;
};
